import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

let initialState = {
  list: {
    order: "",
    status: "",
    shop: "",
    date: "",
    deliveryType: "",
  },
};

export const orderFilterReducer = createSlice({
  name: "ordersfilter",
  initialState,
  reducers: {
    updateFilter: (state, action) => {
      state.list = { ...state.list, ...action.payload };
    },
    orderFilterDestore: (state, action) => {
      state.list = initialState.list;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateFilter, orderFilterDestore } = orderFilterReducer.actions;

export default orderFilterReducer.reducer;
